<script setup>
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    text: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    options: {
        type: Array,
        default: () => []
    },
    visible: {
        type: Boolean,
        default: true
    },
    readonly: {
        type: Boolean,
        default: false
    },
    errmsg: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    height: {
        type: String,
        default: '3rem'
    },
    border: {
        type: Boolean,
        default: false
    },
    horizontalAlign: {
        type: String,
        default: 'left'
    },
    verticalAlign: {
        type: String,
        default: 'top'
    },
    scroll: {
        type: Boolean,
        default: false
    },
    labelEmpty: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue', 'click']);
const ValidationMsg = ref('');
const errMessage = ref(props.errmsg);
const isReadonly = computed(() => props.readonly);

onMounted(() => {
    // emit('update:modelValue', props.modelValue);
});

const handleClick = () => {
    // emit('update:modelValue', 'click');
    emit('click', 'click');
};
</script>

<template>
    <div
        v-if="visible"
        class="flex flex-col"
        :style="{
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight
        }"
    >
        <label v-if="!labelEmpty" :class="['label-font mb-1']">
            {{ label }}
        </label>

        <div
            :style="{
                border: border ? '0.1rem solid #d1d5db' : 'none',
                height: height,
                overflowY: scroll ? 'none' : 'auto',
                display: 'flex',
                alignItems: verticalAlign === 'center' ? 'center' : verticalAlign === 'bottom' ? 'flex-end' : 'flex-start',
                justifyContent: horizontalAlign === 'center' ? 'center' : horizontalAlign === 'right' ? 'flex-end' : 'flex-start'
            }"
            class="label-container"
        >
            <span :id="inputId" @click="handleClick" :title="title" :class="['label-custom', required ? 'label-required' : 'text-black dark:text-gray-300']">
                <i v-if="icon" :class="icon" class="mr-2"></i>
                <span v-html="text"></span>
            </span>
        </div>
    </div>
</template>

<style scoped>
.label-font {
    font-family: 'SCoreDream500';
    display: flex;
    align-items: center;
    margin-bottom: 0.25rem;
    margin-left: 0.25rem;
    height: 0.5rem;
}

.label-container {
    border-radius: 0.5rem;
    padding: 0.5rem;
    transition: all 300ms ease-in-out;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.label-container::-webkit-scrollbar {
    display: none;
}

.label-required {
    color: #f87171;
}

.label-required::before {
    content: '※';
    color: #f87171;
    margin-right: 0.25rem;
}

.label-custom {
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    color: black;
    white-space: normal;
}

/* .label-container::-webkit-scrollbar {
    width: 0.5rem;
}

.label-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
}

.label-container::-webkit-scrollbar-thumb {
    background: #c9c6c6;
    border-radius: 8px;
}

.label-container::-webkit-scrollbar-thumb:hover {
    background: #727272;
} */
</style>
